import { defineMessages } from 'react-intl';

export const paybackMessages = defineMessages({
  externalCardHeadline: {
    id: 'Payback.ExternalCard.Headline',
    defaultMessage: 'Meine PAYBACK Coupons',
    description: 'Headline for external Payback coupon card',
  },
  headline: {
    id: 'Payback.Headline',
    defaultMessage: 'Mein PAYBACK',
    description: 'Main Payback section headline',
  },
  dialogCancelButton: {
    id: 'Payback.Dialog.CancelButton',
    defaultMessage: 'Abbrechen',
    description: 'Cancel button text in Payback dialog',
  },
});
